import Header from "../Common/Layout/Header";
import SideBar from "../Common/Layout/Sidebar";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import config from "../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../Common/Layout/CustomAlerts";
const initialFieldValues = {
  name: "",
  email: "",
  phoneNumber: "",
};
export default function Profile() {
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const userId = localStorage.getItem("userId");
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };
  const validate = () => {
    let temp = {};
    temp.name = values.name === "" ? false : true;
    temp.email = values.email === "" ? false : true;
    temp.phoneNumber = values.phoneNumber === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      const formData = new FormData();
      formData.append("userId", userId);
      formData.append("name", values.name);
      formData.append("email", values.email);
      formData.append("phoneNumber", values.phoneNumber);

      addOrEdit(formData);
    }
  };

  const applicationAPI = () => {
    return {
      update: (updateRecord) =>
        axios.put(
          config.APIACTIVATEURL + config.UPDATEUSERPROFILE,
          updateRecord,
          {
            ...headerconfig,
          }
        ),
    };
  };

  const addOrEdit = (formData) => {
    applicationAPI()
      .update(formData)
      .then((res) => {
        if (res.data.statusCode === 200) {
          handleSuccess(res.data.data);

          GetUserData();
        } else {
          handleError(res.data.data);
        }
      })
      .catch(function (error) {
        handleError("Error in updating data");
      });
  };

  const GetUserData = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETUSERBYID + "/" + userId, {
        ...headerconfig,
      })
      .then((response) => {
        setValues(response.data.data);
      });
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";
  useEffect(() => {
    GetUserData();
  }, []);
  return (
    <div id="layout-wrapper">
      <Header></Header>
      <SideBar></SideBar>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">User Profile</h4>
                </div>
              </div>
            </div>
            <div className="alert alert-success">
              <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                <div className="row">
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label htmlFor="name" className="form-label">
                        Name
                      </label>
                      <input
                        type="text"
                        value={values.name}
                        name="name"
                        onChange={handleInputChange}
                        className={"form-control" + applyErrorClass("name")}
                        placeholder="Name"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">
                        Email
                      </label>
                      <input
                        type="text"
                        value={values.email}
                        name="email"
                        onChange={handleInputChange}
                        className={"form-control" + applyErrorClass("email")}
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label htmlFor="phoneNumber" className="form-label">
                        Phone Number
                      </label>
                      <input
                        type="text"
                        value={values.phoneNumber}
                        name="phoneNumber"
                        onChange={handleInputChange}
                        className={
                          "form-control" + applyErrorClass("phoneNumber")
                        }
                        placeholder=" Phone Number"
                      />
                    </div>
                  </div>

                  <div className="col-lg-2">
                    <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                      <button type="submit" className="btn btn-primary">
                        Update Profile
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
